import React from 'react';

/**
 * @param {'hint' | 'table'} emptyMode — `hint`: one line, no table shell; `table`: legacy empty row
 */
const ProjectSummaryTable = ({
  columns,
  rows,
  emptyText = 'No rows.',
  className = '',
  emptyMode = 'hint',
  meta,
}) => {
  const count = rows?.length ?? 0;

  if (!count) {
    if (emptyMode === 'hint') {
      return (
        <div className={`sm-proj-empty ${className}`}>
          {meta ? <p className="sm-table-meta">{meta}</p> : null}
          <p className="sm-proj-empty__text">{emptyText}</p>
        </div>
      );
    }
    return (
      <div className={`sm-table-wrap ${className}`}>
        <table className="sm-table">
          <tbody>
            <tr>
              <td colSpan={columns.length} className="sm-table-empty-cell">
                {emptyText}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className={`sm-table-block ${className}`}>
      {meta ? <p className="sm-table-meta">{meta}</p> : null}
      <p className="sm-table-meta sm-table-meta--count">Showing {count.toLocaleString('en-IN')} record(s)</p>
      <div className="sm-table-wrap">
        <table className="sm-table">
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.key} className={c.align === 'right' ? 'sm-num' : undefined} scope="col">
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {columns.map((c) => {
                  const raw = row[c.key];
                  const content = c.render ? c.render(raw, row) : raw ?? '—';
                  const isEllipsis =
                    c.align !== 'right' && c.key !== 'projectName' && String(content).length > 48;
                  return (
                    <td
                      key={c.key}
                      className={`${c.align === 'right' ? 'sm-num' : ''} ${isEllipsis ? 'sm-ellipsis' : ''}`.trim()}
                      title={isEllipsis ? String(content) : undefined}
                    >
                      {content}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProjectSummaryTable;
